<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2>Password Reset</h2>
  </div>
</div>


<div class="panel panel-card">
  <div class="panel-heading">
    <div class="panel-heading">
      <div class="card-header bp-card-header">
        <i class="fas fa-user payment-options-icon" style="float: left;"></i>
        <p class="font-weight-light bp-text">Login Information</p>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="panel-body login-info-content">
      <span>The username and email address associated with your profile.</span>
      <br />
      <div class="row margin-top-bottom-15">
        <div class="col-sm-4"><strong>Username:</strong> {{userName}}</div>
        <div class="col-sm-4"><strong>Email:</strong> {{userEmail}}</div>
        <div class="col-sm-4">
          <button class="btn btn-primary margin-left-10 float-right" (click)="confirmResetPW()">Reset Password</button>
          <button class="btn btn-primary float-right" (click)="updatePW()">Update Password</button>
        </div>
      </div>
      <div class="row margin-top-bottom-15" *ngIf="showConfimation">
        <hr/>
        <div class="col-sm-6"><span class="float-right bp-medium-text">Are you sure you want to reset your password?</span></div>
        <div class="col-sm-6">
          <button class="btn btn-primary" (click)="forgetPassword()">Confirm</button>
          <button class="btn btn-default" (click)="cancelResetPW()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/login-info-container/login-info-container.component.html